/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component } from "react";
import orderClasses from "../../orders/orders.module.css";
import reportClasses from "../reports.module.css";
import Input from "../../../../component/inputpm";
import Loader from "../../../../component/loader";
import IconButton from "@mui/material/IconButton";
import { connect } from "react-redux";
import actionTypes from "../../../../store/actions";
//import Select from '../../../component/select';
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import BusApiCall from "../../../../helper/axios";
import constants from "../../../../helper/constants";
import { withTranslation, Trans } from "react-i18next";
import Tooltip from "@mui/material/Tooltip";
import SyncIcon from "@mui/icons-material/Sync";
import InventoryReportTable from "./inventoryReportTable";
import Breadcrumb from "../../../../component/breadcrumb";
import Paper from "@mui/material/Paper";
import { SearchIcon, ClearIcon } from "../../../../component/icons/icons";
import { Grid } from "@mui/material";

// Manage order page class
class InventoryReport extends Component {
  // Declare property values that belongs to the component
  state = {
    inventoryList: [],
    rowsPerPage: 10,
    page: 1,
    startRecord: 1,
    totalInventoryCount: 0,
    sortBy: "",
    sortOrder: "",
    facilityId: "",
    facilityName: "",
    productCode: "",
    productName: "",
    productSupplierId: "",
    productTypeId: "",
    statusId: "",
    offsetQOHQty: "",
    offsetATPQty: "",
    receivedFromDate: "",
    receivedToDate: "",
    receivedFromDateISO: "",
    receivedToDateISO: "",
    inventoryItemTypeId: "",
    customerId: "",
    description: "",

    warehouseList: [
      {
        name: "All Warehouse",
        value: "",
      },
      {
        name: "MediDev Warehouse (New)",
        value: "MediDev_NEW",
      },
      {
        name: "MediDev Warehouse (Failed)",
        value: "MediDev_FAILED",
      },
      {
        name: "MediDev Warehouse (Returns)",
        value: "MediDev_RETURNS",
      },
      {
        name: "PatientGaurd Warehouse (New)",
        value: "PatientGaurd_NEW",
      },
      {
        name: "PatientGaurd Warehouse (Failed)",
        value: "PatientGaurd_FAILED",
      },
      {
        name: "PatientGaurd Warehouse (Returns)",
        value: "PatientGaurd_RETURNS",
      },
      {
        name: "korewl IoT Warehouse",
        value: "DT_IOT_FWH",
      },
    ],

    supplierList: [
      {
        name: "All Supplier",
        value: "",
      },
      {
        name: "KORE Wireless",
        value: "korewl",
      },
    ],

    statusList: [
      {
        name: "All Status",
        value: "",
      },
      {
        value: "INV_NS_ON_HOLD",
        name: "On Hold (Non-Serialized)",
      },
      {
        value: "INV_NS_DEFECTIVE",
        name: "Defective (Non-Serialized)",
      },
      {
        value: "INV_NS_RETURNED",
        name: "Returned (Non-Serialized)",
      },
      {
        value: "INV_ON_ORDER",
        name: "On Order",
      },
      {
        value: "INV_AVAILABLE",
        name: "Available",
      },
      {
        value: "INV_PROMISED",
        name: "Promised",
      },
      {
        value: "INV_DELIVERED",
        name: "Delivered",
      },
      {
        value: "INV_ACTIVATED",
        name: "Activated",
      },
      {
        value: "INV_DEACTIVATED",
        name: "Deactivated",
      },
      {
        value: "INV_ON_HOLD",
        name: "On Hold",
      },
      {
        value: "INV_BEING_TRANSFERED",
        name: "Being Transfered",
      },
      {
        value: "INV_BEING_TRANS_PRM",
        name: "Being Transfered (Promised)",
      },
      {
        value: "INV_RETURNED",
        name: "Returned",
      },
      {
        value: "INV_DEFECTIVE",
        name: "Defective",
      },
    ],
    bread: [
      { title: "Reports", url: "/inventoryReport" },
      { title: "Inventory Report", url: "/inventoryReport" },
    ],
  };

  // Intial HTTP calls or data manipulation on page load
  componentDidMount() {
    this.props.setCompDidMount();
    this.getInventory();
  }

  // Fetch orders list
  getInventory = () => {
    this.setState({
      loading: true,
    });
    let pageOptions = {
      batchSize: this.state.rowsPerPage,
      startRecord: this.state.startRecord,
    };

    // START: Store order filters data
    var jsonData = {
      facilityId: this.state.facilityId,
      productCode: this.state.productCode,
      productName: this.state.productName,
      productSupplierId: this.state.productSupplierId,
      statusId: this.state.statusId,
      inventoryItemTypeId: this.state.inventoryItemTypeId,
      customerId: this.state.customerId,
      description: this.state.description,
    };
    BusApiCall(
      "GET",
      `${constants.busInternalUrl}/reports?sortBy=${this.state.sortBy}&sortOrder=${this.state.sortOrder}&reportType=INVENTORY_REPORT&jsonData=${encodeURIComponent(JSON.stringify(jsonData))}`,
      {},
      pageOptions,
    )
      .then((res) => {
        //let data = JSON.parse(res);
        this.setState({
          inventoryList: res.data.inventoryReport.productInventoryList,
          totalInventoryCount: +res.headers["x-total-count"],
          loading: false,
        });
      })
      .catch((e) => {
        if (e.response) {
          this.props.setErrorMessage(e.response.data.message, false);
        } else {
          this.props.setErrorMessage("Something went wrong", false);
        }
        this.setState({ loading: false });
      });
  };

  // Change page
  handleChangePage = (event, newPage) => {
    this.setState(
      {
        page: newPage,
        startRecord: this.state.rowsPerPage * (newPage - 1) + 1,
      },
      () => {
        this.getInventory();
      },
    );
  };

  // Change rows per page
  handleChangeRowsPerPage = (event) => {
    this.setState(
      {
        page: 1,
        rowsPerPage: event.target.value,
        startRecord: 1,
      },
      () => {
        this.getInventory();
      },
    );
  };

  // Change table sorting
  updateSorting = (by) => {
    if (by === this.state.sortBy) {
      this.setState(
        {
          sortOrder: this.state.sortOrder === "DESC" ? "ASC" : "DESC",
          page: 1,
          startRecord: 1,
        },
        () => {
          this.getInventory();
        },
      );
    } else {
      this.setState(
        {
          sortBy: by,
          sortOrder: "ASC",
          page: 1,
          startRecord: 1,
        },
        () => {
          this.getInventory();
        },
      );
    }
  };

  // Update state data on input change
  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  // Search/Filter orders
  filterTable = () => {
    this.props.setErrorMessage("", false);

    this.setState(
      {
        page: 1,
        startRecord: 1,
        // customerBan: '',
        // customerName: '',
        // featureCode: '',
        // settlementId: '',
        // itemDescription: '',
      },
      () => {
        this.getInventory();
      },
    );
  };

  // Clear all search filters
  clearFilters = () => {
    this.props.setErrorMessage("", false);
    this.setState(
      {
        facilityId: "",
        facilityName: "",
        productCode: "",
        productName: "",
        productSupplierId: "",
        productTypeId: "",
        statusId: "",
        offsetQOHQty: "",
        offsetATPQty: "",
        receivedFromDate: "",
        receivedToDate: "",
        receivedFromDateISO: "",
        receivedToDateISO: "",
        page: 1,
        startRecord: 1,
        inventoryItemTypeId: "",
        customerId: "",
        description: "",
      },
      () => {
        this.getInventory();
      },
    );
  };

  // Search orders on press enter key
  onSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      this.filterTable();
    }
  };

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  classes = { ...orderClasses, ...reportClasses };

  // Render order view
  render() {
    const { t } = this.props;
    return (
      <div className={"newContentWrapper"}>
        <div className={"breadcrumbWrapper"}>
          <div className={"breadcrumbContent"}>
            <Grid container>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <Breadcrumb list={this.state.bread} />
              </Grid>
            </Grid>
          </div>
        </div>
        <main>
          <Paper className="tablePaper">
            {/* Search filters start */}
            <div
              className={this.classes.searchOuterDiv}
              style={{ marginBottom: "5px" }}
            >
              <div>
                <FormControl
                  variant="outlined"
                  size={"small"}
                >
                  <InputLabel id="inventoryItemTypeId">
                    {t("INVENTORY_TYPE_ID")}
                  </InputLabel>
                  <Select
                    native
                    label={t("INVENTORY_TYPE_ID")}
                    value={this.state.inventoryItemTypeId}
                    onChange={(e) => {
                      this.onChange(e);
                    }}
                    onKeyDown={(e) => {
                      this.onSearchKeyDown(e);
                    }}
                    labelId="inventoryItemTypeId"
                    inputProps={{
                      name: "inventoryItemTypeId",
                    }}
                  >
                    <option value=""></option>
                    <option value={"SERIALIZED_INV_ITEM"}>
                      {t("SERIALIZED")}
                    </option>
                    <option value={"NON_SERIAL_INV_ITEM"}>
                      {t("NON_SERIALIZED")}
                    </option>
                  </Select>
                </FormControl>
              </div>
              <div>
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={t("CUSTOMER_ID")}
                  value={this.state.customerId}
                  name={"customerId"}
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  divClass={this.classes.inputClass}
                  onKeyDown={(e) => {
                    this.onSearchKeyDown(e);
                  }}
                />
              </div>
              <div>
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={t("FEATURE_CODE")}
                  value={this.state.productCode}
                  name={"productCode"}
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  divClass={this.classes.inputClass}
                  onKeyDown={(e) => {
                    this.onSearchKeyDown(e);
                  }}
                />
              </div>
              <div>
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={t("PRODUCT_NAME")}
                  value={this.state.productName}
                  name={"productName"}
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  divClass={this.classes.ordInputClass}
                  onKeyDown={(e) => {
                    this.onSearchKeyDown(e);
                  }}
                />
              </div>
              <div>
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={t("DESCRIPTION")}
                  value={this.state.description}
                  name={"description"}
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  divClass={this.classes.ordInputClass}
                  onKeyDown={(e) => {
                    this.onSearchKeyDown(e);
                  }}
                />
              </div>
              {/* <div>
                        
                        <FormControl variant="outlined" className="custom-select-input" size={'small'}>
                            <InputLabel htmlFor="productSupplierId">
                            Supplier Name</InputLabel>
                            <Select
                                native
                                value={this.state.productSupplierId}
                                onChange={(e) => { this.onChange(e) }}
                                onKeyDown={(e) => { this.onSearchKeyDown(e) }}
                                inputProps={{
                                    name: 'productSupplierId',
                                    id: 'productSupplierId',
                                }}
                            >
                                <option value=""></option>
                                {this.state.supplierList.map((opt, key) => (
                                    <option key={key} value={opt.id}>{opt.name}</option>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                    <div>
                        <FormControl variant="outlined" className="custom-select-input" size={'small'}>
                            <InputLabel htmlFor="statusId">
                            Status </InputLabel>
                            <Select
                                native
                                value={this.state.statusId}
                                onChange={(e) => { this.onChange(e) }}
                                onKeyDown={(e) => { this.onSearchKeyDown(e) }}
                                inputProps={{
                                    name: 'statusId',
                                    id: 'statusId',
                                }}
                            >
                                <option value=""></option>
                                {this.state.statusList.map((opt, key) => (
                                    <option key={key} value={opt.id}>{opt.name}</option>
                                ))}
                            </Select>
                        </FormControl>
                    </div> */}
              {/* <div>
                        <Input
                            size={'small'}
                            variant={'outlined'}
                            placeholder="QOH minus Min Stock less than"
                            value={this.state.offsetQOHQty}
                            name={"offsetQOHQty"}
                            onChange={(e) => { this.onChange(e) }}
                            divClass={this.classes.dateInputClass}
                            onKeyDown={(e) => { this.onSearchKeyDown(e) }}
                        />
                    </div>

                    <div>
                        <Input
                            size={'small'}
                            variant={'outlined'}
                            placeholder="ATP minus Min Stock less than"
                            value={this.state.offsetATPQty}
                            name={"offsetATPQty"}
                            onChange={(e) => { this.onChange(e) }}
                            divClass={this.classes.dateInputClass}
                            onKeyDown={(e) => { this.onSearchKeyDown(e) }}
                        />
                    </div> */}

              {/* <div className={this.classes.searchOrderLabelOuter} style={{ paddingRight: 0 }}>
                                <div className={this.classes.searchOrderLabelInner} style={{ paddingRight: 0 }}> */}
              <div style={{ display: "flex", alignItems: "flex-start" }}>
                <Tooltip title="Search">
                  <IconButton
                    className="iconButtonSecondary"
                    onClick={this.filterTable}
                  >
                    <SearchIcon />
                  </IconButton>
                </Tooltip>{" "}
                &nbsp;
                <Tooltip title="Clear">
                  <IconButton
                    className="iconButtonSecondary"
                    onClick={this.clearFilters}
                  >
                    <ClearIcon />
                  </IconButton>
                </Tooltip>
              </div>
              {/* </div> */}
            </div>
            {/* Search filters end */}

            <InventoryReportTable
              list={this.state.inventoryList}
              rowsPerPage={this.state.rowsPerPage}
              totalInventoryCount={this.state.totalInventoryCount}
              page={this.state.page}
              handleChangePage={this.handleChangePage}
              handleChangeRowsPerPage={this.handleChangeRowsPerPage}
              sortBy={this.state.sortBy}
              sortOrder={this.state.sortOrder}
              updateSorting={this.updateSorting}
            />
          </Paper>
          <Loader loading={this.state.loading} />
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loggedInUserId: state.auth.loggedInUserId,
    loggedInUserType: state.auth.userLoginType,
  };
};

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(InventoryReport));
